var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"speechbubble"},[_c('p',[_vm._t("default"),_c('span',{staticClass:"username"},[_vm._v(_vm._s(_vm.username))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }